export default function sanitizeOptionValue(value) {
  return value
    .replace(new RegExp(window.theme.discontinued_suffix, "i"), "")
    .trim();
}
